var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiamond = function SvgDiamond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.813.838A2 2 0 0 0 14.187 0H5.813C5.169 0 4.56.313 4.146.899l-4 6.581a1 1 0 0 0 .11 1.188l9 10a.994.994 0 0 0 1.487.001l9-10a1 1 0 0 0 .11-1.188zM10 16.505 3.245 9h13.509zM2.777 7l3.036-5 8.332-.062L17.222 7z"
  })));
};
export default SvgDiamond;